<mat-form-field appearance="fill">
  <mat-label i18n="label @@form.new.password.label">Create your password</mat-label>
  <input matInput [type]="type" [formControl]="control" [tcAutofocus]="autofocus" autocomplete="off">
  <button type="button" matSuffix mat-icon-button (click)="toggleObfuscated()">
    <mat-icon>{{ icon }}</mat-icon>
  </button>
  <mat-hint align="end">
    {{ length }} / {{ maxLength }}
  </mat-hint>
  <mat-error [ngSwitch]="error">
    <ng-container *ngSwitchCase="'required'" i18n="error @@common.error.password.required">
      Enter a password
    </ng-container>
    <ng-container *ngSwitchCase="'minlength'" i18n="error @@form.new.password.min.length">
      Use at least {{ minLength }} characters
    </ng-container>
    <ng-container *ngSwitchCase="'maxlength'" i18n="error @@form.new.password.max.length">
      Use a maximum of {{ maxLength }} characters
    </ng-container>
    <ng-container *ngSwitchCase="'pattern'" i18n="error @@form.new.password.pattern">
      Use at least one uppercase letter, one lowercase letter and one digit
    </ng-container>
  </mat-error>
</mat-form-field>
